import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { Patient } from '@/core/models/patient.model'
import { Dialog, DialogContent } from '@mui/material'
import { InfoPatientPage } from '@/pages/patient'
import { useIsWebView } from '@/hooks/useSizeBreakpoints'

export type PatientControlCardProps = {
  patient: Patient
  avatarUrl?: string
}

export function PatientInfosCard(props: PatientControlCardProps) {
  const { patient } = props
  const { t, i18n } = useTranslation()
  const isWebView = useIsWebView()
  const [patientProfileDialog, setPPDialog] = useState(false)

  const onClose = () => setPPDialog(false)

  const onClick = () => {
    if (isWebView) setPPDialog(true)
    else window.open(`/patients/${patient._id}`, '_blank')
  }

  return (
    <Card sx={{ p: isWebView ? 2 : 5 }}>
      {patient ? (
        <Stack alignItems="center" spacing={3}>
          <Avatar sx={{ width: '50px', height: '50px' }} />
          <Stack alignItems="center" justifyContent="center">
            <Typography sx={{ color: '#4338CA', fontSize: '24px', fontWeight: 700 }}>{patient.userInfo.surname}</Typography>
            <Typography sx={{ color: '#4338CA', fontSize: '24px', fontWeight: 700 }}>{patient.userInfo.name}</Typography>
          </Stack>
          {patient.userInfo.gender && (
            <Typography sx={{ color: '#222', fontSize: '20px', fontWeight: 700 }}>{patient.userInfo.gender === 'M' ? 'Homme' : 'Femme'}</Typography>
          )}
          <Stack alignItems="center" spacing={1}>
            <Typography sx={{ color: '#000', fontSize: '16px', fontWeight: 400 }}>
              {dayjs(patient.userInfo.birthday).locale(i18n.language).format('LL')} ({dayjs().diff(dayjs(patient.userInfo.birthday), 'years')} ans)
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '16px', fontWeight: 400 }}>{patient.email}</Typography>
            <Typography sx={{ color: '#000', fontSize: '16px', fontWeight: 400 }}>{patient.contactInfo?.phone}</Typography>
          </Stack>
          <Stack alignItems="center" spacing={2}>
            <Button sx={{ fontSize: '12px' }} color="secondary" disableElevation onClick={onClick} variant="contained">
              {t('page.patients.accessPatientPageButton.label')}
            </Button>
          </Stack>
        </Stack>
      ) : (
        <Stack spacing={1}>
          <Typography sx={{ color: '#DC143C', align: 'center', fontSize: '16px', fontWeight: 600 }}>
            {t('page.expertise.patientInfos.noPatient.title')}
          </Typography>
          <Typography sx={{ color: '#4338CA', fontSize: '14px', fontWeight: 100 }}>{t('page.expertise.patientInfos.noPatient.message')}</Typography>
        </Stack>
      )}
      <Dialog
        onClose={onClose}
        open={patientProfileDialog}
        PaperProps={{
          sx: {
            minWidth: '800px',
          },
        }}
      >
        <DialogContent>
          <InfoPatientPage patientId={patient._id} />
        </DialogContent>
      </Dialog>
    </Card>
  )
}

export default PatientInfosCard
